// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"not-found_wrapper__AZhvF"};